module.exports = __webpack_public_path__ + "media/images/about_us_brian-03fa9bcc4d2f46c707d2752fe06c948509c063feb13bbbcb980fa8cf264ff131.jpg";